import styles from './ContactPage.module.scss';

import { contactData } from '../../../data/contact';
import { FaFacebookF, FaWhatsapp } from 'react-icons/fa';
import ContactForm from '../../vievs/ContactForm/ContactForm';

const ContactPage = () => {
  return (
    <div className={styles.contact}>
      <div>
        <h1 className={styles.title}> Skontaktuj się z nami</h1>
        <p className={styles.info}>
          Jesteśmy tutaj, aby odpowiedzieć na Twoje pytania i pomóc dobrać
          odpowiednią formę wsparcia.
        </p>
      </div>

      {/* contact  */}
      <div className={styles.contactBox}>
        {contactData.map((item, index) => (
          <div className={styles.box} key={index}>
            <div className={styles.header}>
              <div className={styles.icons}>{item.icon}</div>
              <h3>{item.title}</h3>
            </div>
            <p>{item.description}</p>
            {item.href ? (
              <a
                href={item.href}
                target={item.href.startsWith('http') ? '_blank' : '_self'}
                rel='noopener noreferrer'
              >
                {item.value}
              </a>
            ) : (
              <p>{item.value}</p>
            )}
          </div>
        ))}
      </div>
      {/* extra contact */}
      <div>
        <h2 className={styles.sectionTitle}> Pozostałe formy kontaktu</h2>
      </div>
      <div className={styles.specialContact}>
        {/* facebook */}
        {/* =================== */}
        <div className={styles.box}>
          <div className={styles.header}>
            <a
              href='https://www.facebook.com/CRTMOTUS'
              target='_blank'
              rel='noopener noreferrer'
            >
              <div className={styles.facebook}>
                <FaFacebookF />
              </div>
              <div>
                <h3>Facebook</h3>
                <p>Wiadomości i aktualizacje </p>
              </div>
            </a>
          </div>
        </div>
        {/* whatsapp */}
        {/* ====================== */}
        <div className={styles.box}>
          <div className={styles.header}>
            <a
              href='https://wa.me/+48668700455'
              target='_blank'
              rel='noopener noreferrer'
            >
              <div className={styles.whatsapp}>
                <FaWhatsapp />
              </div>
              <div>
                <h3>WhatsApp</h3>
                <p>Szybka wiadomość</p>
              </div>
            </a>
          </div>
        </div>
      </div>

      <ContactForm />
      <div className={styles.boxSpecial}>
        <h1>Dane bankowe </h1>
        <p>
          <span>Bank:</span> PEKAO S.A.
        </p>
        <p>
          <span>Nr rachunku:</span> 29 1240 5080 1111 0011 4232 4717{' '}
        </p>
      </div>
      <br></br>
      <br></br>
      <div>
        <h2 className={styles.sectionTitle}> Często zadawane pytania </h2>
      </div>

      <div className={styles.asksContact}>
        <div className={styles.box}>
          <h3>Jak szybko otrzymam odpowiedź?</h3>
          <p>
            Zwykle odpowiadamy w ciągu 24 godzin. W pilnych sprawach skontaktuj
            się telefonicznie.
          </p>
        </div>
        <div className={styles.box}>
          <h3>Jaka jest pierwsza wizyta?</h3>
          <p>
            Zapoznajemy się z Tobą, rozumiemy Twoje potrzeby i opracowujemy plan
            wsparcia.
          </p>
        </div>
        <div className={styles.box}>
          <h3>Czy możemy się spotkać online?</h3>
          <p>Tak, prowadzimy terapię online.</p>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
